import type { RequestQuickBooksLinkJobMutation } from "~/gql/mutations/fernieAccounting.generated";
import type {
	FernieQuickBooksLinksQuery,
	FernieStripeTaxCodeCandidatesQuery,
	QuickBooksLinkJobQuery
} from "~/gql/queries/fernieAccounting.generated";

export const fernieAccountingEndpoints = {
	FernieQuickBooksLinks: {
		providesTags: ["FernieQuickBooksLinks"] as AddTagTypes,
		transformResponse: (res: FernieQuickBooksLinksQuery) => res
	},
	FernieStripeTaxCodeCandidates: {
		providesTags: ["FernieStripeTaxCodeCandidates"] as AddTagTypes,
		transformResponse: (res: FernieStripeTaxCodeCandidatesQuery) => res
	},
	QuickBooksLinkJob: {
		providesTags: (_result: QuickBooksLinkJobQuery | undefined, _error: unknown, { jobId }: { jobId: string }) => [
			{ type: "QuickBooksLinkJob" as const, id: jobId }
		],
		transformResponse: (res: QuickBooksLinkJobQuery) => res
	},
	RequestQuickBooksLinkJob: {
		transformResponse: (res: RequestQuickBooksLinkJobMutation) => res
	}
};
